// extracted by mini-css-extract-plugin
export var cartFooter = "cart-footer-module--cartFooter--113a6";
export var cartFooter__btn = "cart-footer-module--cartFooter__btn--480a5";
export var cartFooter__sale = "cart-footer-module--cartFooter__sale--f0d00";
export var cartFooter__subtotal = "cart-footer-module--cartFooter__subtotal--beaba";
export var cdMaintenanceText = "cart-footer-module--cd-maintenance-text--45255";
export var isOpen = "cart-footer-module--isOpen--0e663";